/**
 * Created by bcole on 10/11/17.
 */
import React from 'react'

export default class IconRuler extends React.Component {

    render() {
        return (
            <svg id="icon-ruler" viewBox="0 0 32 32" fill="currentColor" className={this.props.className}>
                <title>ruler</title>
                <path
                    d="M6.058 6.835l0.686 0.686-2.808 2.808 2.188 2.188 2.821-2.821 0.641 0.641-2.821 2.822 2.16 2.159 6.416-6.416-7.812-7.766-6.393 6.393 2.114 2.115 2.808-2.809zM23.099 16.659l-6.416 6.417 2.159 2.159 2.822-2.821 0.641 0.641-2.821 2.821 2.188 2.188 2.807-2.808 0.686 0.686-2.807 2.808 2.113 2.114 6.394-6.394-7.766-7.811zM29.822 8.451c0.781-0.782 0.787-2.045 0.012-2.821l-3.512-3.511c-0.775-0.775-2.039-0.771-2.82 0.012l-2.17 2.17 6.32 6.32 2.17-2.17zM3.398 25.942l2.623 2.623 5.284-1.877-6.030-6.030-1.877 5.284zM20.65 4.943l-14.885 14.886 6.369 6.369 14.886-14.886-6.37-6.369zM8.657 19.816l11.981-11.981 0.698 0.698-11.982 11.982-0.697-0.699zM10.053 21.213l11.98-11.981 0.698 0.698-11.981 11.98-0.697-0.697zM11.449 22.608l11.981-11.981 0.697 0.698-11.98 11.981-0.698-0.698zM1.954 30.010l3.066-1.117-1.949-1.949-1.117 3.066z"></path>
            </svg>
        )
    }
}